export default {
  textEditorBold: {
    label: 'Bold text',
    keys: ['super+b'],
    default: false,
    desc: 'Toggle bold'
  },
  textEditorItalicize: {
    label: 'Italic text',
    keys: ['super+i'],
    default: false,
    desc: 'Toggle italic/important text'
  },
  textEditorUnderline: {
    label: 'Underlined text',
    keys: ['super+u'],
    default: false,
    desc: 'Toggle underline'
  }
};
